"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateContactPerson = exports.useCreateContactPerson = exports.useSearchContactPerson = exports.useFetchContactPerson = void 0;
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const contactPersonAction_1 = require("./contactPersonAction");
const useFetchContactPerson = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchContactPersonLoading = (0, react_redux_1.useSelector)((state) => state['contactPerson/fetch'].loading);
    const fetchContactPersonError = (0, react_redux_1.useSelector)((state) => state['contactPerson/fetch'].error);
    const fetchContactPersonData = (0, react_redux_1.useSelector)((state) => state['contactPerson/fetch'].data);
    const fetchContactPerson = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        const userLogged = (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, contactPersonAction_1.fetch)(payload));
    });
    return {
        fetchContactPersonLoading,
        fetchContactPersonError,
        fetchContactPersonData,
        fetchContactPerson
    };
};
exports.useFetchContactPerson = useFetchContactPerson;
const useSearchContactPerson = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const searchContactPersonLoading = (0, react_redux_1.useSelector)((state) => state['contactPerson/search'].loading);
    const searchContactPersonError = (0, react_redux_1.useSelector)((state) => state['contactPerson/search'].error);
    const searchContactPersonData = (0, react_redux_1.useSelector)((state) => state['contactPerson/search'].data);
    const searchContactPerson = (query) => __awaiter(void 0, void 0, void 0, function* () {
        const userLogged = (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, contactPersonAction_1.search)(query));
    });
    return {
        searchContactPersonLoading,
        searchContactPersonError,
        searchContactPersonData,
        searchContactPerson
    };
};
exports.useSearchContactPerson = useSearchContactPerson;
const useCreateContactPerson = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const createContactPersonLoading = (0, react_redux_1.useSelector)((state) => state['contactPerson/create'].loading);
    const createContactPersonError = (0, react_redux_1.useSelector)((state) => state['contactPerson/create'].error);
    const createContactPersonData = (0, react_redux_1.useSelector)((state) => state['contactPerson/create'].data);
    const createContactPerson = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const userLogged = (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, contactPersonAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload.message);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Failed to create contact person");
            }
        }
        catch (err) {
            onComplete(false, true, err.message);
        }
    });
    return {
        createContactPersonLoading,
        createContactPersonError,
        createContactPersonData,
        createContactPerson
    };
};
exports.useCreateContactPerson = useCreateContactPerson;
const useUpdateContactPerson = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const updateContactPersonLoading = (0, react_redux_1.useSelector)((state) => state['contactPerson/update'].loading);
    const updateContactPersonError = (0, react_redux_1.useSelector)((state) => state['contactPerson/update'].error);
    const updateContactPersonData = (0, react_redux_1.useSelector)((state) => state['contactPerson/update'].data);
    const updateContactPerson = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const userLogged = (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, contactPersonAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload.message);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Failed to update contact person");
            }
        }
        catch (err) {
            onComplete(false, true, err.message);
        }
    });
    return {
        updateContactPersonLoading,
        updateContactPersonError,
        updateContactPersonData,
        updateContactPerson
    };
};
exports.useUpdateContactPerson = useUpdateContactPerson;
